<template>
  <div class="welfare_card_components">
    <div class="welfare_card">
      <div class="welfare_card-ribbon">
        <span>
          {{title}}
        </span>
      </div>
      <div class="welfare_card-inner">
        <div class="image">
          <div class="image-inner">
            <img :src="image" alt="" :width="size">
          </div>
        </div>
        <div class="text">
          <div class="text-inner">
            {{content}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WelfareCard',
  props: {
    title: String,
    image: String,
    size: String,
    content: String
  }
}
</script>

<style scoped lang="scss">
.welfare_card {
  background-color: #ffce48;
  max-width: 280px;
  // height: 375px;
  position: relative;
  margin-left: 10px;
  border-radius: 10px;
  margin-bottom: 20px;
}
.welfare_card-ribbon {
  background-color: #e51c57;
  top: 30px;
  position: absolute;
  width: 100%;
  color: #fff;
  padding-left: 10px;
  right: 0;
  span {
    font-size: 18px;
    margin-left: 20px;
  }
  &:before {
    content: "";
    display: block;
    width: 0;
    height: 0;
    border: 10px solid transparent;
    border-right: 10px solid #851c2f;
    position: absolute;
    left: -10px;
    z-index: -1;
    bottom: -10px;
  }
}
.welfare_card-inner {
  font-size: 12px;
  height: 100%;
  .image {
    height: 60%;
    display: flex;
    justify-content: center;
    align-items: center;
    .image-inner {
      margin-top: 90px;
      margin-bottom: 10px;
    }
  }
  .text {
    line-height: 2em;
    padding: 0 30px 20px 30px;
    height: calc(40% - 20px);
    display: flex;
    flex-direction: column;
  }
}
</style>
